import { Navigate, Outlet } from "react-router-dom";
import useUserStore from "@store/useUserStore";
import { useState, useEffect } from "react";

/**
 * 스태프 전용 라우트 컴포넌트
 * is_staff가 true이거나 is_admin이 true인 사용자만 접근 가능
 * (관리자는 모든 스태프 기능에 접근 가능)
 */
export default function StaffRoute() {
    const userInfo = useUserStore((state) => state.userInfo);
    const [hasStaffAccess, setHasStaffAccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (userInfo === null) {
            setHasStaffAccess(false);
            setIsLoading(false);
            alert("로그인 후 이용할 수 있습니다.");
            return;
        }

        // 스태프이거나 관리자인 경우 접근 허용
        const isStaffOrAdmin = userInfo.is_staff === true;

        if (!isStaffOrAdmin) {
            setHasStaffAccess(false);
            setIsLoading(false);
            alert("강사만 접근 가능한 페이지입니다.");
            return;
        }

        setHasStaffAccess(true);
        setIsLoading(false);
    }, [userInfo]);

    if (isLoading) {
        return <div>로딩 중...</div>;
    }

    return hasStaffAccess ? <Outlet /> : <Navigate to="/home" replace />;
}
